import { motion } from 'framer-motion'
import { SectionTitle } from '@/components/SectionTitle'
import { useLanguage } from '@/i18n/LanguageContext'

export function Sobre() {
  const { t } = useLanguage()

  return (
    <section id="sobre" className="section-padding bg-white">
      <div className="container-custom">
        <SectionTitle
          title={t.sobre.title}
          subtitle={t.sobre.subtitle}
        />
        <motion.div
          className="max-w-4xl mx-auto text-lg text-slate-600 leading-relaxed space-y-6"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-50px' }}
          transition={{ duration: 0.5 }}
        >
          <p>
            {t.sobre.paragraphs[0]}
          </p>
          <p>
            {t.sobre.paragraphs[1]}
          </p>
          <p>{t.sobre.paragraphs[2]}</p>
        </motion.div>
      </div>
    </section>
  )
}
